module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name) + " COUNT(" + _vm._s(_vm.getAllAffectedContainers.length) + ")")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_vm._v("\n              Export to Excel\n            ")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('model-list-select', {
    attrs: {
      "list": _vm.PageList,
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getAllAffectedContainersFunc()
      }
    },
    model: {
      value: (_vm.cont_count),
      callback: function($$v) {
        _vm.cont_count = $$v
      },
      expression: "cont_count"
    }
  }), _vm._v("\n            " + _vm._s(_vm.cont_count) + "\n           \n          ")], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-row', [(_vm.getSingleIncidents.title) ? _c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('h5', [_vm._v(_vm._s("Incident Name : " + _vm.getSingleIncidents.title))])]) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('designation') != 'Admin') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "pressed": _vm.activeButtonBranch,
      "variant": _vm.activeButtonBranch ? 'success' : 'danger'
    },
    on: {
      "click": function($event) {
        _vm.BranchBtnFilter(_vm.activeButtonBranch)
      }
    },
    model: {
      value: (_vm.activeButtonBranch),
      callback: function($$v) {
        _vm.activeButtonBranch = $$v
      },
      expression: "activeButtonBranch"
    }
  }, [_vm._v("Branch\n                " + _vm._s(_vm.activeButtonBranch ? " Filter On" : " Filter Off"))])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleIncidents.description) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h6', [_vm._v(_vm._s("Description : " + _vm.getSingleIncidents.description))]), _vm._v(" "), _c('br')]) : _vm._e()], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getAllAffectedContainers,
      "fields": _vm.AffectedContainersfields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "id_date",
      fn: function(row10) {
        return [_c('StatusAlerts', {
          attrs: {
            "SUBS_alerts": row10.item.alerts
          }
        }), _vm._v(" "), _c('b', [_vm._v("ID Date : " + _vm._s(row10.item.id_date)), _c('br')]), _vm._v(" "), _c('b', [_vm._v("JOB NO : " + _vm._s(row10.item.JOBNO)), _c('br')]), _vm._v(" "), _c('b', [_vm._v("JOB Date : " + _vm._s(row10.item.JOBDate)), _c('br')]), _vm._v(" "), _c('b', [_vm._v("Client Name : " + _vm._s(row10.item.ClientName)), _c('br')]), _vm._v(" "), _c('b', [_vm._v("Branch Name : " + _vm._s(row10.item.BranchName)), _c('br')])]
      }
    }, {
      key: "container_number",
      fn: function(row1) {
        return [_c('b', {
          staticClass: "pull-right mb-1",
          staticStyle: {
            "color": "blue"
          },
          on: {
            "click": function($event) {
              _vm.getShipmentSubscription(row1.item, 'Shipment')
            }
          }
        }, [_vm._v("Container No : " + _vm._s(row1.item.container_number))]), _c('br'), _vm._v(" "), _c('b', {
          staticClass: "pull-right mb-1",
          staticStyle: {
            "color": "blue"
          },
          on: {
            "click": function($event) {
              _vm.getShipmentSubscription(row1.item, 'Subscription')
            }
          }
        }, [_vm._v("Booking No: " + _vm._s(row1.item.booking_number))]), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v("Carrier : " + _vm._s(row1.item.carrier_name))])]
      }
    }, {
      key: "pod_timeofarrival_warning",
      fn: function(row2) {
        return [(row2.item.pod_discharge_prediction) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [(row2.item.pod_discharge_prediction.created) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v(_vm._s(_vm._f("moment")(row2.item.pod_discharge_prediction.created)))]) : _vm._e(), _c('br'), _vm._v(" "), (row2.item.pod_discharge_prediction.predicted) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v(_vm._s(_vm._f("moment")(row2.item.pod_discharge_prediction.predicted)))]) : _vm._e(), _c('br'), _vm._v("\n                Expected in\n                " + _vm._s(_vm.daysDifference(
          row2.item.pod_discharge_prediction.created,
          row2.item.pod_discharge_prediction.predicted
        )) + "\n                Days")]) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "else{{podDischargePrediction(row2",
            rawName: "v-else{{podDischargePrediction(row2.item.pod_discharge_prediction)}}",
            modifiers: {
              "item": true,
              "pod_discharge_prediction)}}": true
            }
          }]
        }), _c('br'), _vm._v(" "), (row2.item.pod_timeofarrival_warning) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v("\n                " + _vm._s(row2.item.pod_timeofarrival_warning.predicted_date_lower))]) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "else{{podDischargePrediction(row2",
            rawName: "v-else{{podDischargePrediction(row2.item.pod_timeofarrival_warning)}}",
            modifiers: {
              "item": true,
              "pod_timeofarrival_warning)}}": true
            }
          }]
        }), _c('br'), _vm._v(" "), (row2.item.pod_vslarrival_planned_initial) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v("Tot\n                " + _vm._s(_vm.daysDifference(
          row2.item.pod_vslarrival_planned_initial,
          row2.item.pod_vslarrival_planned_last
        )) + "\n                Days"), _c('br')]) : _vm._e(), _c('br'), _vm._v(" "), (row2.item.pod_timeofarrival_warning) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v("\n                " + _vm._s(row2.item.pod_timeofarrival_warning.predicted_date_upper)), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "else{{podDischargePrediction(row2",
            rawName: "v-else{{podDischargePrediction(row2.item.pod_timeofarrival_warning)}}",
            modifiers: {
              "item": true,
              "pod_timeofarrival_warning)}}": true
            }
          }]
        })]
      }
    }, {
      key: "pol_arrival_planned_initial",
      fn: function(row2) {
        return [(row2.item.pod_vslarrival_planned_initial) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v("Tot\n                " + _vm._s(_vm.daysDifference(
          row2.item.pol_arrival_planned_initial,
          row2.item.pol_arrival_planned_last
        )) + "\n                Days"), _c('br')]) : _vm._e()]
      }
    }, {
      key: "pol_loc",
      fn: function(row2) {
        return [(row2.item.pol_loc) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v(_vm._s(row2.item.pol_loc.locode))]) : _vm._e()]
      }
    }, {
      key: "tsp1_loc",
      fn: function(row2) {
        return [(row2.item.tsp1_loc) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v(_vm._s(row2.item.tsp1_loc.locode)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "pod_loc",
      fn: function(row2) {
        return [(row2.item.pod_loc) ? _c('span', {
          staticClass: "pull-right mb-1"
        }, [_vm._v(_vm._s(row2.item.pod_loc.locode))]) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d727b502","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ocean-insights/affectedContList.vue
// module id = 2874
// module chunks = 0